<template>
  <v-card class="pa-4" flat>
    <h3 class="d-flex justify-center primary--text mb-4">
      {{ productData.title }}
    </h3>
    <v-form ref="form" v-model="valid" lazy-validation>
      
      <!-- رندر کردن داینامیک رول‌ها -->
      <v-expansion-panels v-model="activePanel" class="mb-6" accordion>
        <v-expansion-panel 
          v-for="(rule, index) in rules" 
          :key="index"
          class="elevation-2 rounded-lg border-primary mb-2"
        >
          <v-expansion-panel-header class="bg-grey-lighten-4 py-2 px-4">
            <template v-slot:default>
              <div class="d-flex justify-space-between align-center w-100 pl-4">
                <span class="text-subtitle-2 font-weight-bold">حالت {{ index + 1 }}</span>
          <v-btn v-if="rules.length > 1" icon color="error" small @click="removeRule(index)">
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
          </div>
          </template>
          </v-expansion-panel-header>
                    <v-expansion-panel-content class="pt-4">
          <v-row class="mb-2 align-center">
            <v-col cols="12" md="12" class="d-flex flex-column">
              <div class="text-caption text-grey mb-1">روش ارسال</div>
              <div class="d-flex align-center">
                <v-checkbox v-model="rule.is_fbd_active" label="دیجی‌کالا" dense hide-details class="mt-0 mr-2"></v-checkbox>
                <v-checkbox v-model="rule.is_fbs_active" label="فروشنده" dense hide-details class="mt-0 mr-2"></v-checkbox>
                <v-checkbox v-model="rule.is_three_hour_delivery_active" label="۳ ساعته" dense hide-details class="mt-0"></v-checkbox>
              </div>
            </v-col>
          </v-row>
          
          <v-row>
            <v-col cols="12" md="6">
              <price-input 
                v-model="rule.min_price" 
                label="حداقل قیمت نهایی" 
                dense 
                :rules="[(v) => !!v || 'الزامی است']" 
                :min="0"
              />
            </v-col>
            <v-col cols="12" md="6">
              <price-input 
                v-model="rule.max_price" 
                label="حداکثر قیمت نهایی" 
                dense
                :rules="[ 
                  (v) => !!v || 'الزامی است',
                  (v) => Number(String(v).replace(/,/g, '')) > Number(String(rule.min_price || 0).replace(/,/g, '')) || 'باید بزرگتر از حداقل قیمت باشد'
                ]"
              />
            </v-col>
            <v-col cols="12" md="6">
              <price-input 
                v-model.number="rule.price_step" 
                label="کسر قیمت"
                :rules="[(v) => !!v || 'الزامی است']"
                min="2000" dense
              />
            </v-col>
            <v-col cols="12" md="6" class="d-flex align-center gap-4">
               <v-switch v-model="rule.has_discount" :true-value="1" :false-value="0" :label="rule.has_discount===1?'تخفیف':'کسر قیمت'" color="primary" hide-details></v-switch>
            </v-col>
          </v-row>
          </v-expansion-panel-content>
          </v-expansion-panel>
          </v-expansion-panels>
    
      <div class="d-flex justify-center mb-6">
        <v-btn  class="btn-get-code rounded-lg" @click="addRule">
          <v-icon left>mdi-plus</v-icon>
          افزودن حالت قیمت‌گذاری جدید
        </v-btn>
      </div>

      <v-divider class="mb-4"></v-divider>

      <!-- وضعیت کلی محصول -->
      <div class="mb-4 d-flex align-center">
        <v-switch v-model="is_enabled" label="وضعیت فعالیت کلی این تنوع" color="primary" hide-details></v-switch>
      </div>

      <div class="d-flex flex-row justify-space-between mt-6">
        <v-btn :loading="saving" class="btn-get-code rounded-lg px-6" @click="saveData" :disabled="!valid">
          <v-icon left>mdi-check</v-icon> ثبت نهایی
        </v-btn>  
        <v-btn :disabled="saving" class="btn-delete rounded-lg px-6" @click="$emit('close')">
          <v-icon left>mdi-close</v-icon> لغو
        </v-btn>        
      </div>
    </v-form>
  </v-card>
</template>

<script>
import priceInput from '../../../core/plugins/TitleRibbon/pages/pickers/priceInput.vue';

export default {
  name: "MultiPricingForm",
  components: { priceInput },
  props: {
    productData: { type: Object, required: true }
  },
  data() {
    return {
      valid: false,
      saving: false,
      loading: true,
      pricingId: null,
      is_enabled: true,
      rules: [],
      activePanel:0,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    getEmptyRule() {
      return {
        min_price: 0,
        max_price: 0,
        price_step: 20000,
        has_discount: 0,
        is_fbd_active: true,
        is_fbs_active: true,
        is_three_hour_delivery_active: true,
        lead_time: 1,
        delivery_time: 0,
        seller_lead_time: 3,
      };
    },
    addRule() {
      this.rules.push(this.getEmptyRule());
            this.$nextTick(() => {
        this.activePanel = this.rules.length - 1;
      });

    },
    removeRule(index) {
      this.rules.splice(index, 1);
      if(this.activePanel >-this.rules.length)
      {
        this.activePanel = Math.max(0, this.rules.length-1);
      }
    },
    async fetchData() {
      try {
        const res = await this.$api.get(`/v1/digikala/multi-pricing/find/${this.productData.id}`);
        const data = res?.data?.data;
        if (data && data.rules && data.rules.length > 0) {
          this.pricingId = data.id;
          this.is_enabled = data.is_enabled;
          this.rules = data.rules;
        } else {
          this.rules = [this.getEmptyRule()];
        }
      } catch (e) {
        this.rules = [this.getEmptyRule()];
      } finally {
        this.loading = false;
        this.activePanel = 0;
      }
    },
    validateDuplicates() {
            const parsedRules = this.rules.map(rule => ({
                min: Number(String(rule.min_price || 0).replace(/,/g, '')),
                max: Number(String(rule.max_price || 0).replace(/,/g, '')),
                fbd: Boolean(rule.is_fbd_active),
                fbs: Boolean(rule.is_fbs_active),
                three_hour: Boolean(rule.is_three_hour_delivery_active)
            }));

            for (let i = 0; i < parsedRules.length; i++) {
                for (let j = i + 1; j < parsedRules.length; j++) {
                const rule1 = parsedRules[i];
                const rule2 = parsedRules[j];

                const isSameShipping = rule1.fbd === rule2.fbd && 
                                        rule1.fbs === rule2.fbs && 
                                        rule1.three_hour === rule2.three_hour;

                const isSamePrice = rule1.min === rule2.min && rule1.max === rule2.max;

                if (isSameShipping) {
                    this.$toast.error(`ترکیب روش‌های ارسال در حالت ${i + 1} دقیقاً با حالت ${j + 1} تکراری است.`,{timeout:5000});                
                    this.activePanel = i; 
                    return false;
                }

                if (isSamePrice) {
                    this.$toast.error(`اعداد بازه قیمتی در حالت ${i + 1} دقیقاً با حالت ${j + 1} تکراری است.`,{timeout:5000});                
                    this.activePanel = i; 
                    return false;
                }
                }
            }
            return true;
            },

    async saveData() {
        if (!this.$refs.form.validate()) {

        return;
      }
      if (!this.validateDuplicates()) return; 
      this.saving = true;
      const payload = {
        product_id: this.productData.product_id,
        variant_id: this.productData.variant_id,
        is_enabled: this.is_enabled,
        rules: this.rules.map(rule => ({
          ...rule,
          min_price: Number(String(rule.min_price).replace(/,/g, '')),
          max_price: Number(String(rule.max_price).replace(/,/g, '')),
        }))
      };

      const url = this.productData.id 
        ? `/v1/digikala/multi-pricing/${this.productData.id}` 
        : `/v1/digikala/multi-pricing/store`;
      const method = this.productData.id ? 'put' : 'post';

      try {
        await this.$api[method](url, payload);
        this.$toast.success("تنظیمات قیمت‌گذاری با موفقیت ذخیره شد.");
        this.$emit('saved');
      } catch (error) {
        this.$toast.error("خطا در ذخیره‌سازی.");
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>
